<div class="timeline-holder left">
    <div class="content">
      <h2>Dec-2018</h2>
      <p>The first line of code for the project is written. Initially called sunriseprofessor.</p>
    </div>
  </div>
